// Single-source-of-truth platform detection. The `Capacitor` global is only
// injected by the native shell, so its presence is our proxy for "running
// inside iOS/Android wrappers" vs. the regular browser PWA.
export const isNativePlatform = (): boolean =>
  typeof window !== 'undefined' &&
  Boolean(
    (window as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.(),
  );
